/** Read an impact category value from an API / table row. */
export function getImpactCategoryValue(row, categoryKey) {
  if (!row || !categoryKey) return 0;
  const raw =
    row[categoryKey] ??
    row[`impact_${categoryKey}`] ??
    row.impact_categories?.[categoryKey] ??
    0;
  const num = typeof raw === "number" ? raw : parseFloat(raw);
  return Number.isFinite(num) ? num : 0;
}

export function formatImpactComparisonValue(value) {
  if (value == null || value === "") return "-";
  const num = typeof value === "number" ? value : parseFloat(value);
  if (!Number.isFinite(num)) return "-";
  return num.toFixed(4);
}
